import React, { Component } from 'react';
import { readBinaryFile, sheetToJson } from '../../../util/xlsxHelper';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@mui/material/MenuItem';
import {Col, Row} from 'react-bootstrap';
import Button from '../../../components/button';
import Preloader from '../../../components/preloader';
import RuleContent from './rule-content';
import RulesetPrimaryDetails from './ruleset-primary-details';
import Modal from '../../../components/modal';
import EmptyState from '../../../components/empty-state-container';
import RulePrimaryKeyAutocomplete from './primaryid-autocomplete';
import OneOptAutocomplete from './oneopt-autocomplete';
import ComponentErrorBoundary from '../../../components/component-error-boundary';
import {connect} from 'react-redux';

let hasChanged;

import {loadDsList,loadDsDetails} from '../../../common-redux/common.actions';


class NewRuleConfigSetting extends Component {

  constructor(props) {
    super(props);
    this.state = {
      startConfigButtonStatus:true,
      fileColumns:[],
      loadingSource:"",
      fieldsForSource1:[],
      fieldsForSource2:[],
      colsForSource1: "",
      colsForSource2:"",
      source1:null,
      source2:null,
      firstfilePrimaryId:[],
      secondfilePrimaryId:[],
      createNew:"",
      rulesetContent:"hide",
      rulesetPrimaryDetails:{ id:"",rulesetName:"", ruleContent: [], valueMap: [], fieldConfig: [], status:"changed"},
      RulesetnameErrorText:"",
      rules: ['n_0'],
      n_0:{id:'n_0',ruleName:"",ruleContent:[],threshold:"",valueMap:[],fieldConfig:[],status:"changed"},
      addRuleButtonStatus:true,
      saveButtonStatus:true,
      ruleNameArray:[],
      displayTablesFromSourceDB1:"hide",
      displayTablesFromSourceDB2:"hide",
      colGeneratorID:null,
      autocompleteSource1:[],
      autocompleteSource2:[],
      modalOpen:false,
      modalTitle:"",
      modalContent:"",
      deleteRuleVal:"",
      uploadFileStatus:"hide",
    };

    this.props.getDsList();

  }


  componentDidUpdate(prevProps) {

   if(this.props.isLoading !== prevProps.isLoading){
     if(this.props.isLoading.includes('dsdetails')){
          this.preloaderForDs(this.state.loadingSource)

     } else if(this.props.dsDetails !== prevProps.dsDetails){
         if(this.props.dsDetails !==""){
         this.generateValuesFromDs(this.state.loadingSource);
       }
     }
   }
 }


 preloaderForDs=(source)=>{
   source === "source1" ? this.setState({colsForSource1:<Preloader loading={true} />}) : this.setState({colsForSource2:<Preloader loading={true} />});
   }

 generateValuesFromDs=(source)=>{

   let sourceCols=this.props.dsDetails.datasourceCols

   let columnValsDisplay=[];
   let columnVals=[];

   for(let i=0;i<sourceCols.length;i++){
                   columnVals.push({ label: sourceCols[i].name , value: sourceCols[i].name , datatype:"", origin:source })
                   columnValsDisplay.push(<MenuItem key={i} value={sourceCols[i].name}>{sourceCols[i].name}</MenuItem>);
                 }


  source === "source1" ? this.setState({ fieldsForSource1:columnVals,colsForSource1:columnValsDisplay },()=>{this.checkStartConfigStatus();}) :
  this.setState({ fieldsForSource2:columnVals,colsForSource2:columnValsDisplay },()=>{this.checkStartConfigStatus();});





 }




  startConfig = (prevStep,Nextstep) =>{
    this.setState({
      [prevStep]:"hide",
      [Nextstep]:""
    });
    this.props.hideBackNavigation();
    this.updateRulename();
  }

  toggleBackdrop=()=>{
    this.state.backdrop ? this.setState({backdrop:false}) : this.setState({backdrop:true})
  }

  saveConfig=()=>{
    let finalRules=[];
    let itemName,source1Primary,source1Columns,source2Primary,source2Columns;
    for(let i=0; i< this.state.rules.length; i++)
    {
      itemName=this.state.rules[i];
      finalRules.push(this.state[itemName]);
    }

    var k;

//-- generating primary for source1--

    if(this.state.sourceSelect1==="db"){
      source1Primary=this.state.firstfilePrimaryId.COLUMN_NAME;
      source1Columns=[]
      for(k=0;k<this.state.source1.length;k++){
        source1Columns.push(this.state.source1[k].COLUMN_NAME)
      }
    } else{
      source1Primary=this.state.firstfilePrimaryId;
      source1Columns=this.state.source1;
    }

//-- generating primary for source2--

    if(this.state.sourceSelect2==="db"){
      source2Primary=this.state.secondfilePrimaryId.COLUMN_NAME
      source2Columns=[]
      for(k=0;k<this.state.source2.length;k++){
        source2Columns.push(this.state.source2[k].COLUMN_NAME)
      }
    } else{
      source2Primary=this.state.secondfilePrimaryId;
      source2Columns=this.state.source2;
    }


    let ruleObj={
      rulesetName: this.state.rulesetPrimaryDetails.rulesetName,
      primaryKey:this.state.rulesetPrimaryDetails,
      //file1primary:source1Primary,
      //file2primary:source2Primary,
      //file1Columns:source1Columns,
      //file2Columns:source2Columns,
      source1:this.state.source1,
      source2:this.state.source2,
    //  fileColumnsMerged:this.state.fileColumns,
      rules:finalRules
    }
    console.log("NewFinalOBJ",ruleObj);
    this.props.saveFlow(ruleObj,'new');
  }

  resetRulesListForm=()=>{
    var newruleId="n_"+Date.now()
    this.setState({
      startConfigButtonStatus:true,
      fileColumns:[],
      colsForSource1: <MenuItem value={0} label="None" primaryText="None" />,
      source1:null,
      firstfilePrimaryId:[],
      colsForSource2:<MenuItem value={0} label="None" primaryText="None" />,
      source2:[],
      secondfilePrimaryId:[],
      createNew:"",
      rulesetContent:"hide",
      rulesetName:"",
      RulesetnameErrorStatus:false,
      RulesetnameErrorText:"",
      rules: [newruleId],
      [newruleId]:{id:newruleId,ruleName:"",ruleContent:[],threshold:"",valueMap:[],fieldConfig:[],status:"changed"},
      addRuleButtonStatus:true,
      saveButtonStatus:true,
      sourceSelect1:"file",
      sourceSelect2:"file",
      displaySourceFile1:"show",
      displaySourceFile2:"show",
      displaySourceDB1:"hide",
      displaySourceDB2:"hide",
      displayTablesFromSourceDB1:"hide",
      displayTablesFromSourceDB2:"hide",
      source1DB:"",
      source2DB:"",
      source1DBTbl:"",
      source2DBTbl:"",
      colGeneratorID:null
    });
      document.getElementById("input1").value="";
      document.getElementById("input2").value="";

  }

  cancelConfig=()=>{
     this.props.cancelFlow();
  }

  dropdownSelector = (name,value) => {
                        this.setState({[name]:value,loadingSource:name});
                        this.props.getDsDetails(value.datasourceId)
                    }



// uploadRuleTemplate=(input,dropdownName,file,callback) =>
//    {
//      var reader = new FileReader();
//      reader.onload = async function(e) {
//       var data = e.target.result;
//
//       var workbook = await readBinaryFile(data);
//
//       const wsname = workbook.SheetNames[0];
//       const ws = workbook.Sheets[wsname];
//       const sheetdata = XLSX.utils.sheet_to_json(ws, {header:1,blankRows:false});
//       let headerColumn=sheetdata[0];
//       for(let i=0;i<headerColumn.length;i++){
//                       autocompleteVals.push({ label: headerColumn[i] , value: headerColumn[i] , origin: file , datatype:"" })
//                       dropdownval.push(<MenuItem key={i} value={headerColumn[i]} label={headerColumn[i]} primaryText={headerColumn[i]} />);
//                        fileArray.push(headerColumn[i]);
//                     }
//       callback(dropdownName,file,dropdownval,fileArray,autocompleteVals);
//       }
//       reader.readAsBinaryString(input.files[0]);
//    }



addNewRule=()=> {
        var newRule = 'n_'+Date.now();
        this.setState({
           [newRule]:{id:newRule,ruleName:"",ruleContent:[],threshold:"",valueMap:[],fieldConfig:[],status:"changed"},
           addRuleButtonStatus:true,
           saveButtonStatus:true,

         });
        this.setState(prevState => ({ rules: prevState.rules.concat([newRule]) }));
       }

deleteRuleConfirmed=(ruleid)=> {
          var rulesArray = [...this.state.rules];
          var index = rulesArray.indexOf(ruleid)
            if (index !== -1) {
            rulesArray.splice(index, 1);
            this.setState({rules: rulesArray},()=>{this.checkStatus();});
            }


            var ruleNameArray = [...this.state.ruleNameArray]


            var ruleNameIndex = ruleNameArray.findIndex(x => x.ruleName === this.state[ruleid].ruleName )
              if (ruleNameIndex !== -1) {
              ruleNameArray.splice(ruleNameIndex, 1);
              this.setState({ruleNameArray: ruleNameArray});
              }
  }

deleteRule = (ruleid) => {
              if(this.state[ruleid].ruleName==="" && this.state[ruleid].ruleContent.length===0){
                this.deleteRuleConfirmed(ruleid);
              }
              else{
                this.setState({
                  modalOpen:true,
                  modalTitle:"Delete the rule",
                  modalContent:"Are you sure you want to delete \""+this.state[ruleid].ruleName+"\"?",
                  deleteRuleVal:ruleid
                });

              }
    }


  modalClose=()=>{   this.setState({ modalOpen:false }); }

  modalConfirm=()=>{
    this.setState({
      modalOpen:false
    });
    this.deleteRuleConfirmed(this.state.deleteRuleVal);
  }



updateRulesetPrimaryDetails=(value)=>{
  this.setState({
    rulesetPrimaryDetails:value
  },()=>{this.checkSaveButtonStatus();});

}



checkStatus=()=>{
  hasChanged=false;
  for(var i=0;i<this.state.rules.length;i++){
    var ruleId=this.state.rules[i];
    if(this.state[ruleId].status==="changed"){
      hasChanged=true;
      break;
    }
  }

  if(hasChanged===true){
    this.setState({addRuleButtonStatus:true});
  }else{
    this.setState({addRuleButtonStatus:false},()=>{this.checkSaveButtonStatus();});
  }
}

checkSaveButtonStatus=()=>{
  if(this.state.rulesetPrimaryDetails.status==="validated" && this.state.addRuleButtonStatus===false){
      this.setState({saveButtonStatus:false});
  }
  else{
    this.setState({saveButtonStatus:true});
  }
}


updateValues=(value)=> {
    this.setState({
       [value.id]:{id:value.id,ruleName:value.ruleName,ruleContent:value.ruleContent,threshold:value.threshold,valueMap:value.valueMap,fieldConfig:value.fieldConfig,status:value.status}
     },()=>{this.checkStatus();});
  }

updateRulename=()=>{
   var ruleNameArray=[]
    for(var i=0;i<this.state.rules.length;i++){
      var ruleId=this.state.rules[i];
      ruleNameArray.push({id:this.state[ruleId].id,ruleName:this.state[ruleId].ruleName});
    }
    this.setState({ruleNameArray});
  }

  handleRulesetName = (event) => {
    let hasMatch=false;
    //this.updateValueSet(item,event.target.value);
    for(var i=0;i<this.props.ruleSetList.length;i++){
      if(this.props.ruleSetList[i].name.toLowerCase()===event.target.value.toLowerCase()){
        hasMatch=true;
        break;
      }
    }

    if(hasMatch===true){
      this.setState({RulesetnameErrorStatus:true,RulesetnameErrorText:"There is a matching name. Please try a different one.",ruleSetName:event.target.value});
    }else{
      this.setState({RulesetnameErrorStatus:false,RulesetnameErrorText:"",ruleSetName:event.target.value},()=>{this.checkSaveButtonStatus();});
    }
  }

  uploadRuleset = () => {

    var uploadFile = document.getElementById('upload-ruleset').files[0]

     if(uploadFile !== undefined){

      if(uploadFile.name.split('.').pop()==="xlsx"){
        this.setState({
          uploadFileStatus:"hide"
        });

      this.uploadFileReader(uploadFile,this.displayUploadFileError)

      }
      else{
        this.displayUploadFileError();
      }
    }
    else {
      //  do nothing
    }
  }


  displayUploadFileError=()=>{
    this.setState({
      uploadFileStatus:"show file-error"
    });
  }

  uploadFileReader=(input,displayUploadFileError,callback) =>
     {
       var reader = new FileReader();
       reader.onload = async function(e) {
        var data = e.target.result;
        let headerColumn;

        var workbook = await readBinaryFile(data);
        const wsname = workbook.SheetNames[0];
        const ws = workbook.Sheets[wsname];
        const sheetdata = sheetToJson(ws);
        headerColumn=sheetdata[0];
        console.log("headercolumnupload",sheetdata);
        }
        reader.readAsBinaryString(input);
     }


 selectPrimaryIdValue = (fileid,value) =>{
   this.setState({[fileid]:value},()=>{this.checkSaveButtonStatus();});
 }


 checkStartConfigStatus=()=>{
   if(this.state.fieldsForSource1.length>0 && this.state.fieldsForSource2.length>0){
     let autocompleteVals=this.state.fieldsForSource1.concat(this.state.fieldsForSource2)
      this.setState({startConfigButtonStatus:false,fileColumns:autocompleteVals});
   }else{
     this.setState({startConfigButtonStatus:true})
   }
 }



   render() {

     let pageContent;

     if(this.state.rules.length!==0){
     var rulesContentVar=this.state.rules.map(rule => <RuleContent key={rule}
       value={this.state[rule]}
       fileColumns={this.state.fileColumns}
       updateValues={this.updateValues.bind(this)}
       deleteRule={this.deleteRule.bind(this)}
       updateRulename={this.updateRulename.bind(this)}
       ruleNameArray={this.state.ruleNameArray}
       toggleBackdrop={this.props.toggleBackdrop}
       />);
   }
   else{
     rulesContentVar=<EmptyState message="You don't have any rules. If you like to add one please click the Add new rule button." />
   }

   if(this.props.isLoading.includes('dslist')){
     pageContent=<Preloader loading={true} /> ;
   } else{

    pageContent=<div><Row>
     <Col sm={4} xs={6}>
     <div className='rounded-card'>
     <div>
        <label>Choose your Source1</label>
        <OneOptAutocomplete
        label='Select a source'
        fileColumns={this.props.dsList}
        onSelectValue={this.dropdownSelector.bind(this,"source1")}
        value={this.state.source1} />
      </div>
      </div>
     </Col>
     <Col sm={4} xs={6}>
     <div className='rounded-card'>
      <div>
         <label>Choose your Source2</label>
         <OneOptAutocomplete
         label='Select a source'
         fileColumns={this.props.dsList}
         onSelectValue={this.dropdownSelector.bind(this,"source2")}
         value={this.state.source2} />
      </div>
      </div>
     </Col>
     <Col sm={4} xs={12}>
         <Button label="Start configuration" className='btn btn-action btn-start-config' disabled={this.state.startConfigButtonStatus} onClick={this.startConfig.bind(this,"createNew","rulesetContent")}  />
     </Col>
   </Row>
   <Row>
     <Col sm={4} xs={12}>
     <div className='rounded-card'>
      <h3>Fields for Source1</h3>
      <div className='fields-from-source'>{this.state.colsForSource1}</div>
      </div>
     </Col>
     <Col sm={4} xs={12}>
     <div className='rounded-card'>
      <h3>Fields for Source2</h3>
      <div className='fields-from-source'>{this.state.colsForSource2}</div>
      </div>
     </Col>
   </Row></div>
 }

     return (
       <div>

       <Modal
        open={this.state.modalOpen}
        title={this.state.modalTitle}
        content={this.state.modalContent}
        primaryButton="Yes"
        secondaryButton="No"
        close={this.modalClose}
        confirm={this.modalConfirm}
        />

       <div className={this.state.createNew}>
       {pageContent}
       </div>

       <div className={this.state.rulesetContent}>
            <h3>Get started with your business rule(s)</h3>
             <div className='rules-bucket'> {rulesContentVar} </div>

             <Row> <Col sm={12} xs={12} className='text-right'>
              <Button label="Add new rule" className='btn btn-action' disabled={this.state.addRuleButtonStatus}  onClick={this.addNewRule.bind()}  />
             </Col> </Row>

             <div className='rules-bucket'>
                <RulesetPrimaryDetails
                ruleSetList={this.props.ruleSetList}
                rulesetPrimaryDetails={this.state.rulesetPrimaryDetails}
                fileColumns={this.state.fileColumns}
                toggleBackdrop={this.props.toggleBackdrop}
                updateRulesetPrimaryDetails={this.updateRulesetPrimaryDetails.bind(this)}
                />
             </div>



             <Row>
             <Col sm={12} xs={12} className='text-right'>
              <Button label="Cancel" className='btn btn-default' onClick={this.cancelConfig.bind(this)} />

              <Button label="Finish" className='btn btn-action' disabled={this.state.saveButtonStatus} onClick={this.saveConfig.bind(this)}  />

             </Col>

             </Row>
       </div>

         </div>
     );
   }
}

const mapStateToProps = (state) => {
  return{
    error: state.settingsReducer.error,
    isLoading:state.settingsReducer.isLoading.concat(state.commonReducer.isLoading),
    dsList: state.commonReducer.dsList,
    dsDetails:state.commonReducer.dsDetails
  };
};


export const mapDispatchToProps = (dispatch) => {
  return {
    getDsList : () => {
      dispatch(loadDsList());
    },
    getDsDetails : (dsId) => {
      dispatch(loadDsDetails(dsId));
    }
  }
}


export default connect(mapStateToProps,mapDispatchToProps) (NewRuleConfigSetting);
